import { HISTORY_DATE_TIME } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { DeviceListingFieldName, DeviceType } from '../../../devices/components/devices.models';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';

export const historyLogListingModelDeviceTypeFilterModel: FilterModel = {
  // eslint-disable-next-line no-use-before-define
  selected: createDeviceTypeFilterItems(),
  filterType: DeviceListingFieldName.DeviceType,
  isMultiselect: true,
  // eslint-disable-next-line no-use-before-define
  items: createDeviceTypeFilterItems(),
  title: TranslateRegistry.get.FILTER.TITLE.DEVICE_TYPE,
  width: 134
};

export const historyLogListingModelHistoryDateTimeFilterModel: FilterModel = HISTORY_DATE_TIME;

// # Not exported

function createDeviceTypeFilterItems(): FilterModel['items'] {
  return [
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.DCU, value: DeviceType.DCU },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.EXACTAGUARD, value: DeviceType.ExactaGuard },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.METER, value: DeviceType.Meter },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.MTU, value: DeviceType.MTU },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.RDD, value: DeviceType.RDD },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.RMD, value: DeviceType.RMDSensor },
    { text: TranslateRegistry.get.FILTER.DEVICE_TYPE.SBS, value: DeviceType.BaseStation }
  ];
}
